import React, { useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@mui/styles";
import {
    Dialog,
    DialogActions,
    DialogContent,
} from "@mui/material";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import "assets/css/customNotifications.css";
import ReactLoading from "react-loading";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";


const useStyles = makeStyles(styles);
const searchStyle = makeStyles(advancedSearchStyle);


const LoadingDiv = styled.div`
  height: 20vh;
  width: 20vw;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  padding-top: 10vh;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const GroupCell = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;



const styless = (theme) => ({
    root: {
        margin: 0,
        padding: '16px',
    },
    closeButton: {
        position: "absolute",
        right: '8px',
        top: '8px',
        color: '#9e9e9e',
    },
    button: {
        backgroundColor: "",
        bordertopleftradius: 0,
        borderbottomleftradius: 0,
        bordertoprightradius: "5px",
        borderbottomrightradius: "5px",
        height: "34px",
        width: "32px",
        textalign: "center",
        display: "flex",
        alignitems: "center",
        justifycontent: "center",
        "&:hover": {
            cursor: "pointer",
        },
    },
});



const AdvancedSearchResult = (props) => {
    const appContext = useContext(AdvancedSearchContext);
    const { groupInfoListById, page } = appContext;
    const { searchResult } = props;
    const { setResIds } = appContext;

    const [singleSelection, setSingleSelection] = useState(true);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        if (page === 'maps' || page === 'analyse') {
            setSingleSelection(false);
        }
        else
            setSingleSelection(true);
    }, [page]);

    const columns = [
        {
            name: "Nom",
            selector: (row) => row.text,
            sortable: true,
            wrap: true,
        },
        {
            name: "Chemin",
            selector: (row) => row.path,
            sortable: true,
            wrap: true,
            grow: 3,
        }
    ];

    const handleSelectedRowsChange = (selection) => {
        const newSelected = selection.selectedRows.map((row) => row.id);
        if (newSelected && newSelected.length > 0)
            setDisabled(false);
        else
            setDisabled(true);
        setResIds(newSelected);
    };

    const validAndClose = (selection) => {
        props.handleHideAllModal();
    };


    const classes = searchStyle();
    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleHideSearchResult}
                scroll={"paper"}
                fullWidth={true}
                keepMounted
                maxWidth={"md"}
                aria-labelledby="Résultats de la recherche"
                aria-describedby="résultat de la recherche avancée"
            >
                <CustomDialogTitle disableTypography onClose={props.handleHideSearchResult}>
                    Résultats de la recherche
                </CustomDialogTitle>

                <DialogContent dividers className={classes.modalBody}>
                    <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                        noDataComponent={<NoData>Aucun résultat</NoData>}
                        columns={columns}
                        onSelectedRowsChange={handleSelectedRowsChange}
                        persistTableHead
                        pagination
                        noHeader={true}
                        selectableRows={true}
                        selectableRowsSingle={singleSelection}
                        selectableRowsNoSelectAll={singleSelection}
                        paginationComponentOptions={{
                            noRowsPerPage: false,
                            rowsPerPageText: "Lignes par page",
                            rangeSeparatorText: "sur",
                            selectAllRowsItem: false,
                            selectAllRowsItemText: "Selectionner toutes les lignes",
                        }}
                        progressComponent={
                            <div>
                                <LoadingDiv>
                                    <ReactLoading
                                        type={"bars"}
                                        color={"#91c241"}
                                        height={"10%"}
                                        width={"10%"}
                                    />
                                </LoadingDiv>
                            </div>
                        }
                        data={searchResult}
                    />
                </DialogContent>

                <DialogActions>
                    <Button color="warning" onClick={props.handleHideSearchResult}
                        className={classes.buttonsModal}
                    >
                        Retour à la recherche
                    </Button>
                    <Button color={"success"} onClick={() => validAndClose()} className={classes.buttonsModal} disabled={disabled}>
                        Valider la sélection
                    </Button>

                </DialogActions>
            </Dialog>

        </>
    );
};

export default AdvancedSearchResult;
